import { useQuery } from 'react-query'
import colors from '../../config/colors.json'
import { getBackendUrl } from '../../helpers/url'

export default function LiveGameStatistics({ leftPlayer, rightPlayer, leftColor, rightColor }) {
	const fetchCivs = async () => {
		const res = await fetch(`${getBackendUrl()}/api/config/civs`)
		return res.json()
	}

	const { data, status } = useQuery('civs', fetchCivs)

	if (!leftPlayer || !rightPlayer) return

	const leftCiv = data?.find((value) => value.aoe2cm === leftPlayer.civilization || value.label === leftPlayer.civilization)
	const rightCiv = data?.find((value) => value.aoe2cm === rightPlayer.civilization || value.label === rightPlayer.civilization)

	function calculateTCIdleTime(tcIdle) {
		let totalSeconds = tcIdle?.ticksTotal / 8
		let totalActiveSeconds = tcIdle?.ticksActive / 8

		let totalIdleTime = totalSeconds - totalActiveSeconds

		let minutes = Math.floor(totalIdleTime / 60) || 0
		let seconds = Math.floor(totalIdleTime % 60) || 0

		return `${minutes}:${seconds.toString().padStart(2, '0')}`
	}

	function calculateTCEfficiency(tcIdle) {
		//Fallback to 1 so that it always shows 100% and not NaN Bread
		let totalSeconds = tcIdle?.ticksTotal / 8 || 1
		let totalActiveSeconds = tcIdle?.ticksActive / 8 || 1
		return ((totalActiveSeconds / totalSeconds) * 100).toFixed(1)
	}

	return (
		<div
			className="liveGameOverlay__statistics w-[420px] bottom-0 absolute -z-10"
			style={{
				height: '194px',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}>
			<div className="absolute">
				<img
					className="liveGameOverlay__statisticsCivFlag h-[95px] opacity-80"
					src={leftCiv?.originalFlag}
					alt=""
					style={{
						maskImage: `linear-gradient(to left, transparent, black)`,
						WebkitMaskImage: `linear-gradient(to left, transparent, black)`,
					}}
				/>
				<img
					className="liveGameOverlay__statisticsCivFlag h-[95px] opacity-80"
					src={rightCiv?.originalFlag}
					alt=""
					style={{
						maskImage: `linear-gradient(to left, transparent, black)`,
						WebkitMaskImage: `linear-gradient(to left, transparent, black)`,
					}}
				/>
			</div>
			<div className="flex flex-row info z-10">
				<div className="tc-idle flex flex-col z-10 w-[94px] h-48 float-right text-right mt-2" style={{ textShadow: '2px 2px 1px black' }}>
					<div className="text-white text-2xl" style={{ color: colors[leftColor]?.mainColor }}>
						{calculateTCEfficiency(leftPlayer?.villagersIdle)}%
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[leftColor]?.secondaryColor }}>
						{calculateTCIdleTime(leftPlayer?.tcIdle)}
					</div>
					<div className="text-white text-sm mt-1">ECO EFF</div>
					<div className="text-[#dbdbdb] text-sm">TC IDLE</div>
					<div className="text-white text-2xl" style={{ color: colors[rightColor]?.mainColor }}>
						{calculateTCEfficiency(rightPlayer?.villagersIdle)}%
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[rightColor]?.secondaryColor }}>
						{calculateTCIdleTime(rightPlayer?.tcIdle)}
					</div>
				</div>
				<div className="icon-lines flex flex-col z-10 justify-center items-center ml-1 -mr-1">
					<img className="w-[16px] -mb-3" src="/liveGameIcons/vertical_separator.png" alt="" />
					<img className="w-[48px]" src="/liveGameIcons/idle_tc.png" alt="" />
					<img className="w-[16px] mb-3" src="/liveGameIcons/vertical_separator.png" alt="" />
				</div>
				<div className="income-destroyed flex flex-col z-10 w-[110px] h-48 float-right text-right mt-2" style={{ textShadow: '2px 2px 1px black' }}>
					<div className="text-white text-2xl" style={{ color: colors[leftColor]?.mainColor }}>
						{leftPlayer.armyValue || 0}
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[leftColor]?.secondaryColor }}>
						{parseInt(leftPlayer.total_resources?.total || 0)}
					</div>
					<div className="text-white text-sm w-28 -ml-3 mt-1 uppercase">ARMY VALUE</div>
					<div className="text-[#dbdbdb] text-[13px]">COLLECTED</div>
					<div className="text-white text-2xl" style={{ color: colors[rightColor]?.mainColor }}>
						{rightPlayer.armyValue || 0}
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[rightColor]?.secondaryColor }}>
						{parseInt(rightPlayer.total_resources?.total) || 0}
					</div>
				</div>
				<div className="icon-lines flex flex-col z-10 justify-center items-center ">
					<img className="w-[16px]" src="/liveGameIcons/vertical_separator.png" alt="" />
					<img className="w-[48px]" src="/liveGameIcons/improved_deposits.png" alt="" />
					<img className="w-[16px] mb-3" src="/liveGameIcons/vertical_separator.png" alt="" />
				</div>
				<div className="army-eco flex flex-col z-10 w-[92px] h-48 float-right text-right mt-2" style={{ textShadow: '2px 2px 1px black' }}>
					<div className="text-white text-2xl" style={{ color: colors[leftColor]?.mainColor }}>
						{parseInt(leftPlayer?.destroyedValue) || 0}
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[leftColor]?.secondaryColor }}>
						{parseInt(leftPlayer.worker_kills) || 0}
					</div>
					<div className="text-white text-sm mt-1">DESTROYED</div>
					<div className="text-[#dbdbdb] text-sm">ECO KILLS</div>
					<div className="text-white text-2xl" style={{ color: colors[rightColor]?.mainColor }}>
						{parseInt(rightPlayer?.destroyedValue) || 0}
					</div>
					<div className="text-[#dbdbdb] text-xl" style={{ color: colors[rightColor]?.secondaryColor }}>
						{parseInt(rightPlayer.worker_kills) || 0}
					</div>
				</div>
				<div className="icon-lines flex flex-col z-10 justify-center items-center">
					<img className="w-[48px] mb-3" src="/liveGameIcons/eco_army.png" alt="" />
				</div>
			</div>
		</div>
	)
}
